// s
export const baseURL = "https://portalapi.caixadasorte.co.mz/";
// export const baseURL = "http://0.0.0.0:1215/";
// Warning std versions prefixed with 'v' will be deprecated on October 1st 2020. Please change your import to c